import {
  AddShoppingCart,
  Dashboard,
  Group,
  Inventory,
  Inventory2,
  Key,
  LocalShipping,
  ManageAccounts,
  MoreTime,
  Settings,
  ShoppingCart,
  ShoppingCartRounded,
  Store,
} from "@mui/icons-material";

const MenuItems = [
  {
    key: "1",
    title: "Dashboard",
    icon: <Dashboard />,
    route: "/admin/dashboard",
  },
  {
    key: "2",
    title: "Manage Users",
    icon: <ManageAccounts />,
    route: "/admin/users",
    submenus: [
      {
        key: "1",
        title: "Manage Users",
        icon: <Group />,
        route: "/admin/users/manage",
      },
    ],
  },
  {
    key: "3",
    title: "Manage Suppliers",
    icon: <ShoppingCart />,
    route: "/admin/suppliers",
    submenus: [
      {
        key: "1",
        title: "Add Suppliers",
        icon: <LocalShipping />,
        route: "/admin/suppliers/add",
      },
      {
        key: "2",
        title: "View Suppliers",
        icon: <Store />,
        route: "/admin/suppliers/view",
      },
    ],
  },

  {
    key: "4",
    title: "Manage Product",
    icon: <AddShoppingCart />,
    route: "/admin/products",
    submenus: [
      {
        key: "1",
        title: "Add Product",
        icon: <ShoppingCartRounded />,

        route: "/admin/products/add",
      },
      {
        key: "2",
        title: "View Product",
        icon: <Inventory2 />,

        route: "/admin/products/view",
      },
    ],
  },
  {
    key: "5",
    title: "Manage Orders",
    icon: <Inventory />,
    route: "/admin/orders",
  },
  {
    key: "6",
    title: "Settings",
    icon: <Settings />,
    route: "",
    submenus: [
      {
        key: "1",
        title: "Change Password",
        icon: <Key />,
        route: "/changepassword",
      },
      {
        key: "2",
        title: "Change Delivery Timing",
        icon: <MoreTime />,
        route: "/admin/changedeliverytime",
      },
    ],
  },
];

export default MenuItems;
